export default "__VITE_ASSET__Dkw74PIU__"